import { render, staticRenderFns } from "./navT.vue?vue&type=template&id=68bb2772&scoped=true&"
import script from "./navT.vue?vue&type=script&lang=js&"
export * from "./navT.vue?vue&type=script&lang=js&"
import style0 from "./navT.vue?vue&type=style&index=0&id=68bb2772&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bb2772",
  null
  
)

export default component.exports